import {HttpStatus} from "./error/HttpStatus";
import {ApplicationProperties} from "../model/ApplicationProperties";
import {FetchErrorService} from "./error/FetchErrorService";

export class ApplicationPropertiesService {
    protected readonly fetchErrorService = new FetchErrorService();

    async get(): Promise<ApplicationProperties | null> {
        const url = '/api/admin/application-properties';
        const response = await fetch(url);

        if (response.status === HttpStatus.NO_CONTENT) {
            return Promise.resolve(null);
        } else {
            await this.fetchErrorService.checkResponseForError(response);
            return await response.json();
        }
    }
}